import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Adiciona variante do upsell "Complete o presente" via Cart API Horizon.
 * @param {string|number} variantId
 * @param {HTMLButtonElement} botao
 */
async function adicionarUpsell(variantId, botao) {
  const idNumerico = Number(variantId);
  if (!idNumerico) return;

  const sectionIds = [
    ...document.querySelectorAll('cart-items-component[data-section-id]'),
  ]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  const rotas = typeof Theme !== 'undefined' ? Theme.routes : null;
  const cartAddUrl = rotas?.cart_add_url || '/cart/add.js';
  const cartUrl = rotas?.cart_url || '/cart';

  botao.disabled = true;

  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(idNumerico), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const respostaAdd = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: idNumerico, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const dadosAdd = await respostaAdd.json();

    if (dadosAdd.status) {
      deferred.reject(new Error(dadosAdd.message || 'Falha ao adicionar'));
      botao.disabled = false;
      return;
    }

    const respostaCarrinho = await fetch(`${cartUrl}.js`, {
      headers: { Accept: 'application/json' },
    });
    const carrinho = await respostaCarrinho.json();

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrinho),
      detail: {
        sections: dadosAdd.sections,
        items: carrinho.items,
        itemCount: carrinho.item_count,
        source: 'lora-cart-upsell',
        didError: false,
      },
    });
  } catch (erro) {
    console.warn('[lora-cart-upsell]', erro);
    deferred.reject(erro);
    botao.disabled = false;
  }
}

document.addEventListener('click', (evento) => {
  const botao = evento.target?.closest?.('[data-lora-upsell-add]');
  if (!(botao instanceof HTMLButtonElement)) return;
  evento.preventDefault();
  adicionarUpsell(botao.dataset.variantId, botao);
});
